import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchGroups, createGroup, updateGroup, deleteGroup } from "./thunks";
import { ClientGroup } from "@/types";
import { toast } from "react-toastify";

interface PaginatedGroups {
  data: ClientGroup[];
  total?: number;
  currentPage?: number;
  perPage?: number;
}

interface GroupsState {
  groups: PaginatedGroups;
  loading: boolean;
  error: string | null;
}

const initialState: GroupsState = {
  groups: { data: [] },
  loading: false,
  error: null,
};

const GroupSlice = createSlice({
  name: "groups",
  initialState,
  reducers: {
    clearSuppliers: (state) => {
      state.groups = { data: [] };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchGroups.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGroups.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const payload = action.payload;

        if (Array.isArray(payload.data)) {
          // Dados não paginados
          state.groups = { data: payload.data };
        } else {
          // Dados paginados
          state.groups = {
            data: payload.data.data,
            total: payload.data.total,
            currentPage: payload.data.current_page,
            perPage: payload.data.per_page,
          };
        }
      })
      .addCase(fetchGroups.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      })
      // Create
      .addCase(createGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createGroup.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.groups.data.push(action.payload.data);
        toast.success("Grupo cadastrado com sucesso!");
      })
      .addCase(createGroup.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        toast.error("Não foi possível criar esse grupo, tente novamente!");
      })

      // Update
      .addCase(updateGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGroup.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const index = state.groups.data.findIndex(
          (s) => s.id == action.payload.data.id,
        );
        if (index !== -1) {
          state.groups.data[index] = action.payload.data;
        }
        toast.success("Grupo atualizado com sucesso!");
      })
      .addCase(updateGroup.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      })

      // Delete
      .addCase(deleteGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteGroup.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.groups.data = state.groups.data.filter(
          (s) => String(s.id) != action.payload.data.id,
        );
        toast.success("Grupo excluído com sucesso!");
      })
      .addCase(deleteGroup.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
      });
  },
});

export default GroupSlice.reducer;
